import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Register() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-20 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
        <div className="w-full max-w-lg text-center">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-10 space-y-6">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-rocket-line text-3xl text-accent-600" />
            </div>
            <div>
              <h1 className="font-heading text-3xl font-bold mb-2 text-primary-500">Join ClearMind Club</h1>
              <p className="text-foreground-600 font-body leading-relaxed">
                Your membership brings you daily tips, routines, nootropic reviews, productivity tools, and a supportive community of clear-minded people. Our community space is launching soon.
              </p>
            </div>

            <div className="bg-background-100/70 rounded-xl p-5 text-left space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-brain-line text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body"><strong className="text-foreground-950">Daily Tips &amp; Routines</strong> — simple science-backed practices for focus and calm</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-flask-line text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body"><strong className="text-foreground-950">Nootropic Reviews</strong> — honest breakdowns of supplements and cognitive enhancers</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-group-line text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body"><strong className="text-foreground-950">Private Community</strong> — share wins, ask questions, stay accountable</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-tools-line text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body"><strong className="text-foreground-950">Productivity Tools</strong> — frameworks and trackers to stay sharp</p>
              </div>
            </div>

            <div className="font-heading text-3xl font-bold text-primary-500">
              £9.99<span className="text-lg font-body font-normal text-foreground-600">/month</span>
            </div>

            <Link
              to="/community"
              className="w-full inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 bg-accent-500 text-foreground-950 hover:bg-accent-700 h-12 rounded-lg text-base px-8"
            >
              Explore the Community
              <i className="ri-arrow-right-line" />
            </Link>

            <p className="text-xs text-foreground-500 font-body">
              £9.99/month. Cancel anytime. Our community is launching soon — check back shortly.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}